import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=154f756e&scoped=true&"
import script from "./Create.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Create.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f756e",
  null
  
)

export default component.exports